import { defineMessages } from 'react-intl';

const messages: {
	dailyBriefLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dailyBriefAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	chatAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createProjectLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	createProjectAriaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dailyBriefLabel: {
		id: 'rovo-platform-ui-components.thread-card.daily-brief-label.v2',
		defaultMessage: 'Workstream brief',
		description: 'Label for the Workstream brief call-to-action button on a project card',
	},
	dailyBriefAriaLabel: {
		id: 'rovo-platform-ui-components.thread-card.daily-brief-aria-label',
		defaultMessage: 'Get daily brief for {threadTitle}',
		description:
			'Accessible label for the Daily Brief button that opens Rovo Chat with a project brief prompt',
	},
	chatLabel: {
		id: 'rovo-platform-ui-components.thread-card.chat-label',
		defaultMessage: 'Chat',
		description: 'Label for the Chat call-to-action button on a project card',
	},
	chatAriaLabel: {
		id: 'rovo-platform-ui-components.thread-card.chat-aria-label',
		defaultMessage: 'Chat about {threadTitle}',
		description:
			'Accessible label for the Chat button that opens Rovo Chat with the project as context',
	},
	createProjectLabel: {
		id: 'rovo-platform-ui-components.thread-card.create-project-label',
		defaultMessage: 'Create space',
		description: 'Label for the Create space call-to-action button shown on a thread card',
	},
	createProjectAriaLabel: {
		id: 'rovo-platform-ui-components.thread-card.create-project-aria-label',
		defaultMessage: 'Create space from {threadTitle}',
		description: 'Accessible label for the Create space button',
	},
});

export default messages;
